<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <form class="mb-5" @submit.prevent="updateAccount">
          <v-card icon="mdi-account" :title="$t('profile.account')">
            <v-card-text>
              <v-col>
                <v-row>
                  <v-text-field
                    v-model="accountForm.firstName"
                    :label="$t('profile.first_name')"
                    required
                    outlined
                    :error-messages="errorMessages.firstName"></v-text-field>
                </v-row>
                <v-row>
                  <v-text-field
                    v-model="accountForm.lastName"
                    :label="$t('profile.last_name')"
                    required
                    outlined
                    :error-messages="errorMessages.lastName"></v-text-field>
                </v-row>
                <v-row>
                  <v-text-field
                    v-model="accountForm.email"
                    :label="$t('profile.email')"
                    type="email"
                    disabled
                    required
                    outlined
                    :error-messages="errorMessages.email"></v-text-field>
                </v-row>
              </v-col>
              <v-btn :loading="accountUpdating" color="primary" type="submit">{{ $t("profile.update") }}</v-btn>
            </v-card-text>
          </v-card>
        </form>
        <v-card>
          <AppCustomizer />
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <form @submit.prevent="updateTimezone">
          <v-card class="mb-5">
            <v-card-text>
              <v-col>
                <v-row>
                  <TimezonePicker v-model="accountForm.timezone" :label="$t('profile.timezone')" />
                </v-row>
              </v-col>
              <v-btn :loading="timezoneUpdating" color="primary" type="submit">{{ $t("profile.update") }}</v-btn>
            </v-card-text>
          </v-card>
        </form>
        <form @submit.prevent="changePassword">
          <div icon="mdi-lock" :title="$t('profile.password')">
            <v-btn :loading="passwordChanging" color="primary" type="submit">
              {{ $t("profile.password_request") }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import store from "@/store";
  import AppCustomizer from "@core/layouts/components/app-customizer/AppCustomizer.vue";
  import TimezonePicker from "@/components/custom/TimezonePicker.vue";
  import { replaceId } from "@/utility/replaceIdField";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    components: {
      AppCustomizer,
      TimezonePicker,
    },
    data() {
      return {
        userId: "",
        accountUpdating: false,
        timezoneUpdating: false,
        passwordChanging: false,
        accountForm: {
          firstName: null,
          lastName: null,
          email: null,
          timezone: null,
        },
        errorMessages: {},
        appContentWidthOptions: [
          {
            label: "Full Width",
            value: "full",
          },
          {
            label: "Boxed",
            value: "boxed",
          },
        ],
      };
    },
    computed: {
      skinOptions: () => {
        const options = [
          {
            label: "Default",
            value: "default",
          },
          {
            label: "Bordered",
            value: "bordered",
          },
          {
            label: "Semi Dark",
            value: "semi-dark",
          },
        ];

        return options;
      },
    },
    watch: {
      user: {
        handler(newVal) {
          if (newVal) {
            let { firstName, lastName, email } = newVal;
            this.accountForm = {
              firstName,
              lastName,
              email,
            };
          }
        },
        immediate: true,
      },
    },
    mounted() {
      this.getUserInfo();
    },
    methods: {
      async getUserInfo() {
        this.userId = store.state.user.id;

        try {
          const { data } = await this.$admin.dataProvider.customHttpCall("GET", `users/current`);

          this.accountForm = {
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            timezone: data.timezone,
          };
        } catch (err) {
          this.$admin.toast.error(formErrorMessage(err, this.$t("generic.error")));
        }
      },
      async updateAccount() {
        this.accountUpdating = true;

        try {
          if (
            await this.$admin.dataProvider.update("users", {
              id: replaceId(this.userId, "/api/users/"),
              data: {
                firstName: this.accountForm.firstName,
                lastName: this.accountForm.lastName,

                // email: this.accountForm.email,
              },
            })
          ) {
            this.$admin.toast.success(this.$t("profile.account_updated"));
            store.commit("SET_USER_FIRST_NAME", this.accountForm.firstName);
            store.commit("SET_USER_LAST_NAME", this.accountForm.lastName);
            store.commit("SET_USER_EMAIL", this.accountForm.email);
          }
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("error")));
          console.error(e);
        } finally {
          this.accountUpdating = false;
        }
      },
      async updateTimezone() {
        this.timezoneUpdating = true;
        try {
          if (
            await this.$admin.dataProvider.update("users", {
              id: replaceId(this.userId, "/api/users/"),
              data: {
                timezone: this.accountForm.timezone,
              },
            })
          ) {
            this.$admin.toast.success(this.$t("profile.timezone_updated"));
            store.commit("SET_USER_TIMEZONE", this.accountForm.timezone);
          }
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("error")));
          console.error(e);
        } finally {
          this.timezoneUpdating = false;
        }
      },
      async changePassword() {
        this.passwordChanging = true;

        try {
          if (
            await this.$admin.dataProvider.customHttpCall("POST", "auth/reset_password", {
              email: this.accountForm.email,
            })
          ) {
            this.$admin.toast.success(this.$t("profile.password_requested"));
          }
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("error")));
          console.error(e);
        } finally {
          this.passwordChanging = false;
        }
      },
    },
  };
</script>
